import React from "react";
import { company } from "../mock";
import { trackWhatsApp } from "../lib/enquiryShare";

export const WhatsAppIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.96c0 2.36.7 4.56 1.9 6.42L4 29l7.8-1.98a12.2 12.2 0 0 0 4.24.76C22.68 27.78 28 22.42 28 15.8 28 9.2 22.68 3 16.04 3zm0 22.6c-1.34 0-2.66-.3-3.86-.86l-.28-.14-4.62 1.18 1.22-4.42-.18-.3a9.72 9.72 0 0 1-1.6-5.3c0-5.4 4.4-9.8 9.82-9.8 5.42 0 9.8 4.4 9.8 9.86 0 5.42-4.38 9.78-9.8 9.78zm5.4-7.3c-.3-.14-1.74-.86-2.02-.96-.26-.1-.46-.14-.66.14-.2.3-.76.96-.94 1.16-.16.2-.34.22-.64.08-.3-.14-1.24-.46-2.36-1.46-.88-.78-1.46-1.74-1.64-2.04-.16-.3-.02-.46.14-.6.12-.14.3-.34.44-.52.14-.16.2-.3.3-.5.1-.2.04-.36-.02-.5-.08-.14-.66-1.6-.9-2.18-.24-.58-.48-.5-.66-.5h-.56c-.2 0-.52.08-.78.36-.28.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.86 1.2 3.06.16.2 2.08 3.18 5.04 4.46.7.3 1.26.48 1.68.62.7.22 1.36.2 1.86.12.58-.08 1.74-.7 1.98-1.4.24-.68.24-1.26.18-1.38-.08-.14-.28-.2-.6-.34z" />
  </svg>
);

const WhatsAppButton = () => {
  const rawText = "Hello Anjaneya Inks and Coating, I would like to enquire about your inks and coatings.";
  const text = encodeURIComponent(rawText);
  return (
    <a
      href={`https://wa.me/${company.whatsapp}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackWhatsApp(rawText, "floating-button")}
      className="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-button"
    >
      <span className="whatsapp-fab__pulse" aria-hidden="true" />
      <WhatsAppIcon />
      <span className="whatsapp-fab__label">Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
